import { render, staticRenderFns } from "./Major.vue?vue&type=template&id=044b32bf&scoped=true"
import script from "./Major.vue?vue&type=script&lang=js"
export * from "./Major.vue?vue&type=script&lang=js"
import style0 from "./Major.vue?vue&type=style&index=0&id=044b32bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044b32bf",
  null
  
)

export default component.exports